module.exports = __webpack_public_path__ + "static/20-d3ef022f0ccdc29de24147ca666d63c3.png";